var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"loading"},[_c('div',{staticClass:"loading-animation"},[_c('lottie',{attrs:{"options":_vm.loadingDefault}})],1),_c('span',{staticClass:"loading-text"},[_vm._v("Loading...")])])])}
var staticRenderFns = []

export { render, staticRenderFns }